import { ControllerParams } from '@wix/yoshi-flow-editor';

export const normalizeError = (error: any) => {
  if (
    typeof Response !== 'undefined' &&
    error instanceof Response &&
    error.constructor.name !== 'Error'
  ) {
    return Error(`Failed to fetch ${error.url} with status ${error.status} - ${error.statusText}`);
  }
  return error;
};

export const decorateActionsWithLogger = <T extends Record<string, Function>>(
  actions: T,
  errorMonitor: ControllerParams['flowAPI']['errorMonitor'],
  logToConsole: boolean,
): T => {
  const decoratedActions: any = {};
  const decorate =
    (action: Function, key: string) =>
    (...args: any[]) => {
      const captureToSentry = (e: any) =>
        errorMonitor.captureException(normalizeError(e), {
          contexts: { action: { action: key } },
          tags: { ...e.tags, capturedBy: 'action monitor', requestId: e.requestId },
        });
      try {
        const response = action(...args);
        if (response instanceof Promise) {
          response.catch((error) => {
            const status = error?.status ?? error?.response?.status;
            if (![200, 500, 400, 422, 428].includes(status)) {
              return;
            }

            const eventId = captureToSentry(error);
            logToConsole && console.error(error, eventId);
          });
        }
        return response;
      } catch (error) {
        const eventId = captureToSentry(error);
        logToConsole && console.error(error, eventId);
      }
    };

  Object.keys(actions).forEach((key) => {
    const action = actions[key];
    decoratedActions[key] = decorate(action, key);
  });

  return decoratedActions;
};
